import { useMemo, useState } from "react";
import EmploymentListItem from "../ListItems/EmploymentListItem";
import EmploymentEditModal from "../Modals/EmploymentEditModal";
import BreadCrumb from "../Controls/BreadCrumb";
import { DateTime } from "luxon";
import Help from "../Controls/Help";
import { MdAddBox } from "react-icons/md";
import { useEmploymentQuery, useRefreshEmployment } from "../../query/useEmployment";

function compareEmployments(a, b) {
  return DateTime.fromISO(a.StartDate) > DateTime.fromISO(b.StartDate) ? -1 : 1;
}

export default function EmploymentHistory() {
  const refreshEmployment = useRefreshEmployment();
  const { data, isLoading, isError, error } = useEmploymentQuery();
  const [employmentModalId, setEmploymentModalId] = useState(null);

  const employments = useMemo(() => {
    return [...(data?.employmentHistory || [])].sort(compareEmployments);
  }, [data?.employmentHistory]);

  const employers = data?.employers || [];

  async function closeEmploymentModal() {
    setEmploymentModalId(null);
    await refreshEmployment();
  }

  return (
    <div className="pagebody">
      <BreadCrumb props={["Employment History"]} />
      <div className="tabbody">
        <h2>Employment History</h2>
        <Help id={2139} />
        <span className="listTitleIcons">
          <MdAddBox
            data-testid="employment-add"
            role="button"
            aria-label="Add employment"
            onClick={() => setEmploymentModalId(0)}
          />
        </span>

        {isLoading ? <p className="fieldHint">Loading employment…</p> : null}
        {isError ? (
          <p className="fieldHint">{error?.message || "Could not load employment."}</p>
        ) : null}

        {!isLoading && !isError && employments.length === 0 ? (
          <p>You have not entered any employment history</p>
        ) : null}

        <ul className="EmploymentList">
          {employments.map((employment) => (
            <EmploymentListItem
              key={employment.ID}
              employment={employment}
              employers={employers}
              onEdit={(id) => setEmploymentModalId(id)}
            />
          ))}
        </ul>
      </div>
      {employmentModalId !== null ? (
        <EmploymentEditModal
          employmentId={employmentModalId}
          onClose={closeEmploymentModal}
        />
      ) : null}
    </div>
  );
}
